import { Injectable, computed, signal } from '@angular/core';
import type { DelegationFragmentFragment as DelegationFragment } from '@generated/graphql';

@Injectable({
  providedIn: 'root',
})
export class DelegationContextService {
  private readonly _activeDelegations = signal<DelegationFragment[]>([]);

  readonly activeDelegations = this._activeDelegations.asReadonly();
  readonly activeDelegation = computed(() => this._activeDelegations()[0] ?? null);
  readonly isActingAsDelegate = computed(() => this._activeDelegations().length > 0);
  readonly delegatorId = computed(() => this.activeDelegation()?.delegator.id ?? null);

  /**
   * Atualiza a lista de delegações ativadas pelo delegado.
   * Deve ser chamado sempre que as delegações do usuário são carregadas/atualizadas.
   */
  private readonly _pendingDelegations = signal<DelegationFragment[]>([]);

  readonly pendingDelegations = this._pendingDelegations.asReadonly();
  readonly hasPendingDelegations = computed(() => this._pendingDelegations().length > 0);

  syncActiveDelegations(delegations: DelegationFragment[], currentUserId: string) {
    const now = new Date();
    const myDelegations = delegations.filter(
      (d) => d.delegate.id === currentUserId && !d.revoked_at,
    );

    const inPeriod = myDelegations.filter(
      (d) => new Date(d.starts_at) <= now && (!d.ends_at || new Date(d.ends_at) > now),
    );

    this._activeDelegations.set(inPeriod.filter((d) => d.activatedByDelegate));
    this._pendingDelegations.set(inPeriod.filter((d) => !d.activatedByDelegate));
  }

  clearActiveDelegations() {
    this._activeDelegations.set([]);
  }
}
